import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { CellButton, CellButtons } from '../CellButton';
import { PerformActionButton } from '../PerformActionButton';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { carcollectCreate, setVehicleProperties } from '../../../Vehicles/actions';
import { REQUEST_CAR_COLLECT } from '../../../Vehicles/constants';

import { VehiclePropertyLoadable } from '../../../Vehicles/components/VehiclePropertyLoadable';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { HBox, VBox } from '../../../../components/Box';
import { Row } from '../../../../components/List';
import { Cell } from '../Cell';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { KanbanVehicleRemarks } from '../../components/KanbanVehicleRemarks';
import { BaseCellComp } from '../BaseCellComp';

import { performAction } from '../../actions';
import { setVehicleProperty } from '../../../Vehicles/actions';
import { selectVehicle, selectConfig } from '../../../Vehicles/selectors';
import { selectUserId, selectWork, selectWorks } from '../../../Api/selectors';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { getRemarkType } from '../helpers/getRemarkType';
import { COLOR_PRIMARY_1 } from '../../../../vars';
import styles from './HILT.module.css';
import { getPropByName } from '../../../../utils/props';
import { CarcollectCredentialModal } from '../../../Vehicles/components/CarcollectCredentialModal';


const TASK_REMARK_TYPE = 'task_HILT_appraise';
const Container = styled.div`
  .modal-inner {
  }

  .manco-list > div {
    margin: 12px 0;
  }

  .triple {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 12px 0;

    .btn-check:checked + .btn {
      background-color: var(--color-new-secondary);
      border-color: var(--color-new-secondary);
      color: #fff; /* optioneel: tekst wit voor contrast */
    }
    .btn-check:not(:checked) + .btn {
      border-color: var(--color-new-primary);
      color: var(--color-new-primary);
    }

    transition: opacity 0.2s;
    .check {
      transition: opacity 0.2s;
      display: inline-block;
      width: 24px;
      height: 24px;
      border: 1px solid ${COLOR_PRIMARY_1};
      color: ${COLOR_PRIMARY_1};
      text-align: center;
      font-size: 21px;
      line-height: 20px;
    }

    &.triple-0 {
      .check {
      }
    }
    &.triple-1 {
      .check {
        border: 1px solid #3bb78e;
        color: #3bb78e;
      }
    }
    &.triple-4 {
      .check {
        border: 1px solid red;
        text-align: center;
        color: red;
      }
    }

    &.disabled {
      opacity: 0.4;
      .check {
        opacity: 0;
      }
    }
    @media (max-width: 425px) {
      font-size: 12px;
    }
  }
`;

let todaydate = new Date().toISOString();

const STATE = {
  approve: false,
  regplate_code: '',
};

/* eslint-disable react/prefer-stateless-function */
class HILT_appraiseComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.setState({
      HILT_appraise_sum: getPropByName(this.props.vehicle, 'HILT_appraise_sum'),
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.vehicle != this.props.vehicle) {
      this.setState({
        HILT_appraise_sum: getPropByName(this.props.vehicle, 'HILT_appraise_sum'),
      });
    }
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  get tripleCheckProps() {
    let props = ['task_HILT_repair_order'];

    return props;
  }

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  propertyValue(name) {
    return this.props.vehicle[name];
  }

  disableConfirmation() {
    let disable = true;
 
    this.tripleCheckProps.forEach(prop => {
      if (this.props.vehicle?.[prop] === '1' || this.props.vehicle?.[prop] === '2' || this.props.vehicle?.[prop] === '0') {
        disable = false;
      }
    });

    return disable;
  }

  handleCreateClick = () => {
    const { config } = this.props;
    
    // Check if there are multiple credentials available
    if (config?.carcollectCredentials?.length > 0) {
      this.setState({ showCredentialModal: true });
    } else {
      // No credentials or single credential - proceed directly
      this.props.create(() => {
        this.setState({ showAddCarcollect: false, showCarcollectAddMessage: true });
        updateVehicleProperties(vehicleId, {
          task_HILT_advertise: 0,
          task_HILT_advertise_done: 1,
        });
      });
    }
  }

  handleCredentialConfirm = (credentialId) => {
    this.setState({ showCredentialModal: false });
    this.props.create(() => {
      this.setState({ showAddCarcollect: false, showCarcollectAddMessage: true });
    }, credentialId);
  }

  handleCredentialCancel = () => {
    this.setState({ showCredentialModal: false });
  }

  renderDoubleCheck(name) {
    let val = this.propertyValue(name);
    let state = (val === undefined || val === 0) ? null : (val == 1 ? 1 : 0);
   
    return (
      
      <HBox vCenter key={name}>
        <div
          className={`triple triple-${state} ${this.props.work ? 'disabled' : ''}`}
          // onClick={() => this.props.setProperty(name, state == 0 ? 1 : 0)}
        >
          <div className="label">{this.lbl(`vehicle.property.${name}`)}</div>
          <VehiclePropertyLoadable name={name}>
            <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
             
                <>
                  <input
                    type="radio"
                    className="btn-check"
                    name={`btnradio-${name}`} // uniek per veld
                    id={`btnradio1-${name}`}
                    autoComplete="off"
                    checked={state == 1}
                    onChange={() => this.props.setProperty(name, 1)}
                  />
                  <label className={`btn btn-outline-primary ${state == 1 ? 'active' : ''}`} htmlFor={`btnradio1-${name}`}>
                    Ja
                  </label>
                </>
            
              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`}
                id={`btnradio2-${name}`}
                autoComplete="off"
                checked={state == 0}
                onChange={() => this.props.setProperty(name, 0)}
              />
              <label className={`btn btn-outline-primary ${state == 0 ? 'active' : ''}`} htmlFor={`btnradio2-${name}`}>
                Nee
              </label>
            </div>

            {/*<div className="check">{state == 0 ? '-' : '+'}</div>*/}
          </VehiclePropertyLoadable>
        </div>
      </HBox>
    );
  }

  renderTripleCheck(name) {
    let val = this.propertyValue(name);
    let state = val == 1 ? 1 : val == 2 || val == 4 ? 4 : 0;

    return (
      <HBox vCenter key={name}>
        <div
          className={`triple triple-${state} ${this.props.work ? 'disabled' : ''}`}
          // onClick={() => this.props.setProperty(name, state == 0 ? 1 : state == 1 ? 4 : 0)}
        >
          <div className="label">{this.lbl(`vehicle.property.${name}`)}</div>
          <VehiclePropertyLoadable name={name}>
            <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`} // uniek per veld
                id={`btnradio1-${name}`}
                autoComplete="off"
                checked={state == 0}
                onChange={() => this.props.setProperty(name, 0)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio1-${name}`}>
                Todo
              </label>

              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`}
                id={`btnradio2-${name}`}
                autoComplete="off"
                checked={state == 1}
                onChange={() => this.props.setProperty(name, 1)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio2-${name}`}>
                Gereed
              </label>

              <input
                type="radio"
                className="btn-check"
                name={`btnradio-${name}`}
                id={`btnradio3-${name}`}
                autoComplete="off"
                checked={state == 4}
                onChange={() => this.props.setProperty(name, 4)}
              />
              <label className="btn btn-outline-primary" htmlFor={`btnradio3-${name}`}>
                Manco
              </label>
            </div>
            {/*<div className="check">{state == 0 ? '-' : state == 1 ? '+' : 'x'}</div>*/}
          </VehiclePropertyLoadable>
        </div>
      </HBox>
    );
  }

  renderEditableVehicleFields() {
    return (
      <VBox>
        {['HILT_appraise_sum'].map(prop => {
          return (
            <HBox key={prop} vCenter gap={'8px'}>
              {/* <HBox> */}
              {this.lbl(`vehicle.property.${prop}`)}
              <VehiclePropertyLoadable name={prop}>
                <div className={styles.buttonLabel}>
                  <div className={styles.labelCompany}>
                    <input
                      className="form-control"
                      type={prop}
                      value={this.state[prop]}
                      onChange={this.onInputChange.bind(this)}
                      name={prop}
                      key={prop}
                      onBlur={() => {
                        this.state[prop] && this.props.setProperty(prop, this.state[prop]);
                        console.log('onBlur', this.state[prop]);
                      }}
                    />
                  </div>
                  <div className={styles.decoratorLabel}>€</div>
                </div>
              </VehiclePropertyLoadable>
              {/* </HBox> */}
            </HBox>
          );
        })}
      </VBox>
    );
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.props.column.label}>
        <WithVehicle loader vehicle_id={this.vehicle.id}>
          <div className="mb-2">
            <VehicleHeader vehicle={this.vehicle} hooikammer kanbanCell />
          </div>
 
          <Container>
          <ButtonComponent
                style={'ButtonSoftPrimary'}
                disabled={this.vehicle.carcollect_tradedossier_id}
                onClick={() => this.setState({ showAddCarcollect: true })}
              >
                {this.vehicle.carcollect_tradedossier_id
                  ? this.lbl('carcollect.submitted')
                  : this.lbl('vehicle.property.carcollect')}
              </ButtonComponent>
              {this.state.showCarcollectAddMessage && (
                <HBox left vCenter gap={'8px'}>
                  <span>{this.lbl('carcollect.add_message')}</span>
                </HBox>
              )}
                 {this.state.showAddCarcollect && (
                <>
                  <ButtonComponent
                    style={'ButtonSoftPrimary'}
                    onClick={this.handleCreateClick}
                  >
                    {this.lbl('create')}
                  </ButtonComponent>

                  <br />
                </>
              )}
            <VBox className="manco-list" key="manco">
              <Row>
                <Cell>{this.renderEditableVehicleFields()}</Cell>
              </Row>
              <Row>
                <Cell>{this.tripleCheckProps.map(name => this.renderDoubleCheck(name))}</Cell>
              </Row>
            </VBox>
          </Container>
        </WithVehicle>
        <div className="d-flex gap-2 mt-3">
          <PerformActionButton
            disabled={this.disableConfirmation()}
            className={styles.confirmButton}
            action={this.props.action}
            target={this.vehicle}
            onChange={this.reset.bind(this)}
          />

          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
        {this.state.showCredentialModal && (
                  <CarcollectCredentialModal
                    onConfirm={this.handleCredentialConfirm}
                    onCancel={this.handleCredentialCancel}
                  />
                )}
              
      </ModalComponent>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell>
        <Container>
          <VehicleHeader vehicle={vehicle} kanbanCell />

          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <KanbanVehicleRemarks
                    readOnly
                    taskName={TASK_REMARK_TYPE}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.loggedInUserId}
                  />
                )}
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

HILT_appraiseComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle?.id}`]),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
    loggedInUserId: selectUserId(),
    workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-${getRemarkType(TASK_REMARK_TYPE)}`),
        workCarcollect: selectWork(REQUEST_CAR_COLLECT),
        // config: selectConfig(),
    
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
      create(callback, credentialId) {
          dispatch(carcollectCreate(ownProps.cell.vehicle.id, callback, credentialId));
        },
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
    setProperty(name, value) {
      dispatch(setVehicleProperty(ownProps.cell.vehicle.id, name, value));
    },
     updateVehicleProperties(vehicleId, properties, callback) {
          dispatch(setVehicleProperties(vehicleId, properties, callback));
        },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const HILT_appraise = compose(withConnect, withRouter)(HILT_appraiseComp);
